import React from 'react'
import styles from './gallery.module.css'
import { navigateTo } from "gatsby-link"
import { Visibility, Image, Card, Icon, Container, Divider, Header } from 'semantic-ui-react'
import { slash, toSlug } from '../../utils/utils'

const navTo = (url) => {
    navigateTo(url)
}

class Gallery extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      calculations: {
        width: 0
      }
    }
  }

  handleUpdate = (e, { calculations }) => {
    this.setState({ calculations })
  }

  render() {

    const handleClick = (path) => {
      navigateTo(path);
    }
    const breakpoints = [
      { width: 500, col:2 },
      { width: 700, col:3 },
      { width: 900, col: 4},
      { width: 1100, col:5},
      { width: 1300, col: 6},
      { width: 1500, col: 6},
    ];

    const data = this.props.data;
    const { width } = this.state.calculations;
    const { col } = breakpoints.reduce((acc, x) => {
      if(Object.keys(acc).length > 0) { return acc; }
      if(width < x.width) { return x }
      return acc;
    }, {});

    return <Visibility fireOnMount onUpdate={this.handleUpdate}>
      <Container className={styles.gallery}>
       <Card.Group itemsPerRow={col}>
        {data.map(({image, path, title}, i) => {
           return <Card fluid key={i} color='grey' centered={true} onClick={() => handleClick(path)} href={slash(path)} alt={title}>
             {image && <Image width="500" height="500" src={image} size='huge' />}
             <Divider fitted />
             <Header as='h2' textAlign='center' size='tiny' sub>
             {title.toUpperCase()}
             </Header>
             </Card>
        })}
       </Card.Group>
      </Container>
    </Visibility>
  }
}

export default Gallery;



// WEBPACK FOOTER //
// ./src/components/Gallery/index.js